import React, { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { EyeOff } from "lucide-react";
import { useAtomValue } from "jotai";
import { skipDislikeConfirmAtom } from "@/atoms/dislikeConfirmAtom";

interface DislikeConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (skipNextTime: boolean) => void;
}

export const DislikeConfirmModal: React.FC<DislikeConfirmModalProps> = ({
  isOpen,
  onClose,
  onConfirm
}) => {
  const [skipNextTime, setSkipNextTime] = useState(false);
  const skipDislikeConfirm = useAtomValue(skipDislikeConfirmAtom);

  // 確認をスキップする設定の場合、即座に確認処理を実行
  useEffect(() => {
    if (isOpen && skipDislikeConfirm) {
      onConfirm(true);
      onClose();
    }
  }, [isOpen, skipDislikeConfirm, onConfirm, onClose]);

  const handleConfirm = () => {
    onConfirm(skipNextTime);
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="w-80 rounded-lg">
        <div className="flex flex-col items-center gap-4 text-center">
          {/* アイコン */}
          <EyeOff className="mt-4 h-8 w-8 text-gray-600" strokeWidth={1.5} />

          {/* メインテキスト */}
          <div className="my-2 space-y-2">
            <DialogTitle className="text-lg font-semibold">
              スポットを興味なしとして
              <br />
              非表示にしました
            </DialogTitle>
          </div>

          {/* チェックボックス */}
          <div className="my-4 flex items-start space-x-2">
            <Checkbox
              id="skip-confirm"
              checked={skipNextTime}
              onCheckedChange={(checked) => setSkipNextTime(checked as boolean)}
              className="mt-0.5 rounded"
            />
            <label
              htmlFor="skip-confirm"
              className="cursor-pointer select-none text-sm leading-5 text-gray-700"
            >
              次回から確認しない
            </label>
          </div>

          {/* ボタン */}
          <div className="flex w-full flex-col gap-3">
            <Button onClick={handleConfirm} variant="default" className="w-full">
              OK
            </Button>
            <Button onClick={onClose} variant="ghost" className="w-full">
              興味なしを取り消す
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
